




















import { Component, Vue, Prop } from 'vue-property-decorator'
import { RoleComingOut } from '@/class/game'
import Player from './Player.vue'
import Card from '@/components/Common/Card/Card.vue'

@Component({
  components: {
    Player,
    Card
  }
})
export default class ReplaySelfProclaimNoticeViewer extends Vue {
  @Prop() selfProclaimNotice!: RoleComingOut;

  get player() {
    return this.selfProclaimNotice.player
  }

  get comingOutRoleId() {
    return this.selfProclaimNotice.roleId
  }
}
